import apiClient from './client';

export const schoolsServices = {
  getAll: () => apiClient.get('/schools'),
};